import { GitCompareArrows } from "lucide-react";
import { useAppStore } from "../store/useAppStore";

/**
 * Persistent reconciliation indicator. Renders a "Reconcile" button with a red
 * badge showing the pending mismatch count. Hidden entirely when there are no
 * pending mismatches. Clicking surfaces the resolution flow via {@link onClick}.
 */
export default function ReconcileButton({ onClick }: { onClick: () => void }) {
  const pendingCount = useAppStore((s) => s.pendingReconciliationCount);

  if (pendingCount <= 0) return null;

  return (
    <div className="flex justify-end mb-4">
      <button
        type="button"
        onClick={onClick}
        className="relative inline-flex items-center gap-2 rounded-full px-3.5 py-1.5 text-sm font-medium shadow-card bg-card border-[0.5px] border-border text-foreground hover:bg-muted transition-colors"
        aria-label={`Reconcile ${pendingCount} pending mismatch${pendingCount === 1 ? "" : "es"}`}
      >
        <GitCompareArrows className="w-4 h-4 text-muted-foreground" />
        Reconcile
        <span className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-destructive text-destructive-foreground text-[11px] font-semibold leading-none [font-variant-numeric:tabular-nums]">
          {pendingCount}
        </span>
      </button>
    </div>
  );
}
